import Resume from '../../assets/icons/Resume'
import Designs from '../../assets/icons/Designs'
import WorkSatation from '../../assets/icons/WorkStation'
import Projects from '../../assets/icons/Projects'
import './PortfolioBtn.scss'
import { Link } from "react-router-dom";

function PortfolioBtn() {
    return (
        <div className='portfolioBtn grid  md:gap-2 grid-cols-1 md:grid-cols-2 mt-5 mb-5 xl:mr-5'>
            <Link to="./projects" className='flex flex-row justify-start transition duration-500 ease-in-out transform hover:fill-amber-700 hover:text-amber-700 cursor-pointer'>
                <Projects />
                <span className='font-Lato font-semibold uppercase text-sm ml-3 '>Work Projects</span>
            </Link>
            <Link to={process.env.PUBLIC_URL + '/CV_of_Supun_for_Software_Engineer.pdf'} target="_blank" className='flex flex-row justify-start transition duration-500 ease-in-out transform hover:fill-amber-700 hover:text-amber-700 cursor-pointer'>
                <Resume />
                <span className='font-Lato font-semibold uppercase text-sm ml-3 '>Download Resume</span>
            </Link>
            <Link to='./designs' className='flex flex-row justify-start transition duration-500 ease-in-out transform hover:fill-amber-700 hover:text-amber-700 cursor-pointer'>
                <Designs />
                <span className='font-Lato font-semibold uppercase text-sm ml-3 '>Design Artworks</span> 
            </Link>
            <Link to='./workstation' className='flex flex-row justify-start transition duration-500 ease-in-out transform hover:fill-amber-700 hover:text-amber-700 cursor-pointer'>
                <WorkSatation />
                <span className='font-Lato font-semibold uppercase text-sm ml-3 '>Desktop Setup</span>
            </Link>
        </div>
    )
}

export default PortfolioBtn